// extracted by mini-css-extract-plugin
export var closed = "_i9-1";
export var resizer = "_i9-0";